import axios from 'axios';

export const success = (data, params) => {
  return {
    status: 'success',
    isSuccessful: true,
    data,
    params,
  };
};

export const error = (errorMessage, data) => {
  return {
    status: 'error',
    isSuccessful: false,
    message: errorMessage,
    data: data ?? null,
  };
};

// Helper to extract message from response data
const getErrorMessage = (data, defaultMsg = 'Something went wrong') => {
  if (!data) return defaultMsg;
  if (typeof data === 'string') return data;
  if (data.message && typeof data.message === 'string') return data.message;
  if (data.warning && typeof data.warning === 'string') return data.warning;
  if (data.error && typeof data.error === 'string') return data.error;
  return defaultMsg;
};

// Post with Axios
export const axiosPost = async (url, data, headers, auth) => {
  try {
    const res2 = await axios.post(url, data, {
      headers: {
        ...headers,
        Authorization: `Bearer ${auth?.data?.token}`,
      },
    });
    if (res2?.status === 200 || res2?.status === 201) {
      if (res2?.data?.error === true) {
        return error(getErrorMessage(res2?.data), res2?.data);
      }
      return success(res2?.data);
    }
    if (
      res2?.status === 203 ||
      res2?.status === 429 ||
      res2?.status === 500 ||
      res2?.status === 400 ||
      res2?.status === 404
    ) {
      return error(getErrorMessage(res2?.data), res2?.data);
    }
  } catch (e) {
    if (e?.response?.data) {
      return error(
        getErrorMessage(e?.response?.data, e?.message),
        e?.response?.data,
      );
    }
    return error(e?.message || e);
  }
};

export const axiosUpdate = async (url, data, token, headers) => {
  try {
    const res2 = await axios.put(url, data, {
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
    if (res2.status === 200 || res2.status === 201) {
      if (res2?.data?.error === true) {
        return error(getErrorMessage(res2?.data), res2?.data);
      }
      return success(res2?.data);
    }
    if (
      res2?.status === 203 ||
      res2?.status === 429 ||
      res2?.status === 500 ||
      res2?.status === 400 ||
      res2?.status === 404
    ) {
      return error(getErrorMessage(res2?.data), res2?.data);
    }
  } catch (e) {
    if (e?.response?.data) {
      return error(
        getErrorMessage(e?.response?.data, e?.message),
        e?.response?.data,
      );
    }
    return error(e?.message || e);
  }
};

export const axiosGetAPI = async (url, auth, config) => {
  try {
    const res2 = await axios.get(`${url}`, {
      headers: {
        Authorization: `Bearer ${auth?.data?.token}`,
      },
      ...config,
    });
    if (res2.status === 200 || res2.status === 201) {
      if (res2?.data?.error === true) {
        return error(getErrorMessage(res2?.data), res2?.data);
      }
      return success(res2?.data);
    }
    if (
      res2?.status === 203 ||
      res2?.status === 429 ||
      res2?.status === 500 ||
      res2?.status === 400 ||
      res2?.status === 404
    ) {
      return error(getErrorMessage(res2?.data), res2?.data);
    }
  } catch (e) {
    if (e?.response?.data) {
      return error(
        getErrorMessage(e?.response?.data, e?.message),
        e?.response?.data,
      );
    }
    console.error(e);
    return error(e?.message || e);
  }
};

export const axiosDelete = async (url, token, headers = {}) => {
  try {
    const res2 = await axios.delete(url, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
    if (res2.status === 200 || res2.status === 201) {
      if (res2?.data?.error === true) {
        return error(getErrorMessage(res2?.data), res2?.data);
      }
      return success(res2?.data);
    }
    if (
      res2?.status === 203 ||
      res2?.status === 429 ||
      res2?.status === 500 ||
      res2?.status === 400 ||
      res2?.status === 404
    ) {
      return error(getErrorMessage(res2?.data), res2?.data);
    }
  } catch (e) {
    if (e?.response?.data) {
      return error(
        getErrorMessage(e?.response?.data, e?.message),
        e?.response?.data,
      );
    }
    return error(e?.message || e);
  }
};

export const axiosPatchAPI = async (url, auth, data = null, headers = {}) => {
  try {
    const res2 = await axios.patch(url, data, {
      headers: {
        ...headers,
        Authorization: `Bearer ${auth?.data?.token}`,
      },
    });

    if (res2.status >= 200 && res2.status < 300) {
      if (res2?.data?.error === true) {
        return error(getErrorMessage(res2?.data), res2?.data);
      }
      return success(res2?.data);
    }

    return error(getErrorMessage(res2?.data), res2?.data);
  } catch (e) {
    if (e?.response?.data) {
      return error(
        getErrorMessage(e?.response?.data, e?.message),
        e?.response?.data,
      );
    }
    return error(e?.message || e);
  }
};

